import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
    height: '100%',
  },
  text: {
    width: '100%',
    height: '100%',
    resize: 'none',
    overflow: 'hidden',
    minHeight: '100%',
    position: 'absolute',
    border: 'none',
    background: 'none',
    padding: 0,
  },
  divider: {
    alignSelf: 'stretch',
    height: 'auto',
    margin: theme.spacing(1, 0.5),
  },
  toolBar: {
    top: -68,
    left: -5,
    padding: theme.spacing(1),
    position: 'absolute',
    display: 'flex',
    border: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
  },
  clickField: {
    width: '100%',
    height: '100%',
    backgroundColor: '#ffff005c',
    position: 'absolute',
    zIndex: 2,
  },
}))

export default useStyles
